module.exports = __webpack_public_path__ + "img/pic_2.def0ab9f.jpg";